import React from "react";

/**
 * Same card look as RadioOptionGroupSMS, but multi-select (checkbox) instead
 * of mutually-exclusive (radio) -- used where more than one option can be
 * active at once, e.g. inbound + outbound voice sources together.
 */
const CheckboxOptionGroupSMS = ({
  label = "",
  name,
  selectedValues = [],
  onChange,
  options = [],
  columns = 6,
}) => {
  const toggle = (value) => {
    const next = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];
    onChange(next);
  };

  return (
    <div className="form-group" style={{ marginBottom: 0 }}>
      {label && (
        <label className="col-md-12 pd10botbuilder">
          {label}
        </label>
      )}
      <div className="row">
        {options.map((option) => {
          const isDisabled = !!option.disabled;
          const isChecked = selectedValues.includes(option.value);
          return (
            <div className={`col-md-${columns}`} key={option.value}>
              <div
                className="custom-control custom-checkbox"
                style={{
                  border: isChecked
                    ? "1px solid rgb(15, 98, 254)"
                    : "1px solid #e1e5e9",
                  borderRadius: "8px",
                  padding: "3px 3px 3px 35px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  backgroundColor: isChecked ? "#f8f9ff" : "white",
                  transition: "all 0.3s ease",
                  height: "100%",
                  boxSizing: "border-box",
                }}
                onClick={() => !isDisabled && toggle(option.value)}
              >
                <input
                  type="checkbox"
                  id={`${name}_${option.value}`}
                  name={name}
                  className="custom-control-input"
                  value={option.value}
                  checked={isChecked}
                  onChange={() => !isDisabled && toggle(option.value)}
                  style={{ accentColor: "rgb(15, 98, 254)" }}
                  disabled={isDisabled}
                  onClick={(e) => e.stopPropagation()}
                />
                <label
                  className="custom-control-label"
                  htmlFor={`${name}_${option.value}`}
                  style={{
                    color: "#495057",
                    fontWeight: "600",
                    fontSize: "16px",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {option.label}
                </label>
                {option.description && (
                  <div
                    style={{
                      marginTop: "8px",
                      color: "#6c757d",
                      fontFamily: '"Poppins", sans-serif',
                      fontSize: "13px",
                      minHeight: "18px",
                    }}
                  >
                    {option.description}
                  </div>
                )}
                {option.extra && (
                  <div
                    style={{ marginTop: "10px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {option.extra}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxOptionGroupSMS;
